import {useMemo} from 'react';
import {AffiliatedUser} from '../../../../../../../backend/responses/affiliated-user';
import {Option} from '../../../../../../../components/role-autocomplete/autocomplete-input';
import {FetchEntityUsersResult} from '../../../../../../../hooks/use-fetch-entity-users';
import {BaseUsersInput} from '../../../../../../../components/users-input/users-input';
import {translations} from '../../../../../../../i18n/translations';

type PlannerUsersInputProps = {
  usersData: FetchEntityUsersResult;
  defaultOptionLabel?: string;
  onChange?: (user: AffiliatedUser | undefined) => void;
};

export function PlannerUsersInput(props: PlannerUsersInputProps) {
  const options = useMemo(() => {
    if (!props.usersData.items) return [];

    return props.usersData.items.reduce<Option[]>((acc, {user}) => {
      if (!user.isActive) {
        // Since we are receiving ALL users, we need to filter out the inactive ones.
        return acc;
      }

      const u = {
        key: user.id!,
        label: user.displayName || user.name,
        picture: user.picture || '',
      };
      acc.push(u);

      return acc;
    }, []);
  }, [props.usersData.items]);

  return (
    <BaseUsersInput
      options={options}
      loading={props.usersData.isLoading}
      defaultOptionLabel={
        props.defaultOptionLabel ?? translations.planner.header.filter_all_seniors_label
      }
      onChange={(userId) => {
        const user = props.usersData.items?.find(({user}) => user.id === userId);
        props.onChange?.(user);
      }}
    />
  );
}
